
import axios from "axios"
const headers = {
    "Content-Type": "multipart/form-data"
}

export const getPost = async (last) => {
    if (last === null) {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/posts/infinite`);
        return data;
    } else {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/posts/infinite/?post_object_id=${last}`);
        return data
    }
}

export const postPost = async (post) => {
    const { data } = await axios.post(`${process.env.REACT_APP_AWS_URL}/api/posts/postposts`, post, { headers });
    return data
}

export const randomPost = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/posts/random`);
    return data
}